var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('info',{attrs:{"type":1,"infoType":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }